import React from 'react';
import flat from 'lodash/flatten';

export class SelectionItemComponent extends React.PureComponent {
  render() {
    const { value, multiple, data, onClick } = this.props;
    let checked = false;
      let itemValue = '';

    if (typeof data === 'object') {
      itemValue = data.value;
    } else {
      itemValue = data;
    }

    if (multiple) {
      if (value.indexOf(itemValue) > -1) {
        checked = true;
      }
    } else {
      if (value === itemValue) {
        checked = true;
      }
    }

    return (
      <li
        className={checked ? 'selection-info checked selected' : 'selection-info'}
        onClick={onClick}
        data-openid={data.value}
      >
        <div className="selection-addon">
          <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" className="selection-checkmark spaui-component">
            <path fill="currentColor" fillRule="evenodd" d="M2 7.778l1.414-1.414L6.95 9.899l6.365-6.363 1.414 1.414-7.778 7.778L2 7.778z" />
          </svg>
        </div>
        <div className="selection-name">
          <ww-open-data type="userName" openid={data.value} />
        </div>
      </li>
    );
  }
}

export const ValueAreaComponent = (props) => {
  const { value, data, multiple, onOpen, open, placeholder } = props;

  const ids = flat([value]);

  return !value ? (
    <a onClick={onOpen} className="selection-single placeholder">
      <span className="selection-single-text">{placeholder}</span>
    </a>
  ) : (
    <div onClick={onOpen}>
      {
        ids.map((id, index) => (
          <span key={index} className="qw-select-name">
            <span style={{ marginRight: '0px' }}>
              <ww-open-data type="userName" openid={id} />
            </span>
          </span>
        ))
      }
    </div>
  );
};
